import { useMutation } from "@apollo/client";
import { DialogContentText } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useSnackbar } from "notistack";
import React from "react";
import { Test } from "../../graphql/baseTypes";
import { RESEND_TEST_EMAIL } from "../../graphql/mutations";
import { ResendTestAdminMutation } from "../../graphql/mutations/resendEmail";
import { ResendTestAdminMutationVariables } from "../../graphql/types";
import ResendForm, { ResendFormValues } from "./ResendForm";
interface Props {
  id: Pick<Test, "locationId" | "date" | "testId">;
  open: boolean;
  initialValues: ResendFormValues;
  handleClose: () => any;
  params?: object;
}

const ResendDialog: React.FC<Props> = ({
  open,
  handleClose,
  id,
  initialValues,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [resend, { loading: resendLoading }] = useMutation<
    ResendTestAdminMutation,
    ResendTestAdminMutationVariables
  >(RESEND_TEST_EMAIL, {
    onError(error) {
      console.log(error);
      enqueueSnackbar("Email konnte nicht versendet werden!", {
        variant: "error",
      });
    },
    onCompleted({ resendTestAdmin }) {
      if (resendTestAdmin) {
        enqueueSnackbar("Email wurde versendet", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Email konnte nicht versendet werden!", {
          variant: "error",
        });
      }

      handleClose();
    },
  });

  const handleSubmit = ({ email }: ResendFormValues) => {
    const { date, locationId, testId } = id;
    return resend({
      variables: {
        input: {
          testId,
          date,
          locationId,
          ...(email && { email }),
        },
      },
    });
  };

  return (
    <Dialog
      open={open}
      disableBackdropClick={resendLoading}
      disableEscapeKeyDown={resendLoading}
      onClose={handleClose}
      aria-labelledby="test-resend-dialog-title"
    >
      <DialogTitle id="test-resend-title">
        Testbericht erneut versenden
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Sie können eine neue Email-Adresse an die der Test gesendet werden
          soll angeben
        </DialogContentText>
        <ResendForm
          onSubmit={handleSubmit}
          loading={resendLoading}
          initi={initialValues}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ResendDialog;
